var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SliceHeader } from './slice-header';
var cls = classNames('slice-organisations');
import { sprintf } from 'sprintf-js';
import { classNames } from '@shapeable/utils';
import { useEntity } from '../hooks/use-entity';
import { useImage } from '../hooks/use-image';
import { useLang } from '../hooks/use-lang';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
export var SliceOrganisationsDefaultProps = {
  maxRowCount: 5,
  hasHeader: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    ", "\n  "], ["\n    padding-bottom: ", ";\n    ", "\n  "])), theme.UNIT(8), function (_a) {
    var _color = _a._color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.H_DOT_BG_END(_color, 2, 6));
  })
});
var OrganisationsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: ", ";\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    justify-content: space-between;\n  "], ["\n    justify-content: space-between;\n  "])))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", " ", ";\n    box-sizing: border-box;\n    flex-basis: 50%;\n    max-width: 320px;\n\n    img {\n      width: 100%;\n    }\n  "], ["\n    padding: ", " ", ";\n    box-sizing: border-box;\n    flex-basis: 50%;\n    max-width: 320px;\n\n    img {\n      width: 100%;\n    }\n  "])), theme.UNIT(4), theme.UNIT(5)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var count = _a.count,
      maxRowCount = _a.maxRowCount;
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      flex-basis: ", "%;\n      \n    "], ["\n      flex-basis: ", "%;\n      \n    "])), count ? 1 / Math.min(5, count) * 100 : 50);
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(SliceHeader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Organisations: styled.div.attrs(cls.attr('organisations'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), OrganisationsStyles),
  Organisation: styled.a.attrs(cls.attr('organisation'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles)
};
export var SliceOrganisations = function (props) {
  var className = props.className,
    maxRowCount = props.maxRowCount,
    hasHeader = props.hasHeader,
    children = props.children;
  var entity = useEntity(props.entity);
  var color = entity.color,
    themeMode = entity.themeMode;
  var Image = useImage();
  var t = useLang();
  // const { isInverted, color } = sliceColorInfo(entity);
  var activeThemeMode = useActiveThemeMode();
  var isColorInverted = activeThemeMode.themeMode === 'dark';
  var _a = entity.organisations,
    organisations = _a === void 0 ? [] : _a;
  return React.createElement(My.Container, {
    isInverted: isColorInverted,
    className: cls.name(className)
  }, hasHeader && React.createElement(My.Header, {
    _color: (color === null || color === void 0 ? void 0 : color.value) || 'strong',
    entity: entity
  }), React.createElement(My.Organisations, null, organisations.map(function (organisation) {
    var logo = organisation && ((themeMode === null || themeMode === void 0 ? void 0 : themeMode.slug) === 'dark' || (themeMode === null || themeMode === void 0 ? void 0 : themeMode.slug) === undefined && isColorInverted) ? (organisation === null || organisation === void 0 ? void 0 : organisation.logoInverted) || (organisation === null || organisation === void 0 ? void 0 : organisation.logo) : organisation === null || organisation === void 0 ? void 0 : organisation.logo;
    return React.createElement(My.Organisation, {
      maxRowCount: maxRowCount,
      count: organisations.length,
      key: organisation.id,
      target: "_blank",
      href: organisation.url
    }, React.createElement(Image, {
      alt: sprintf(t("%s Logo"), organisation.name),
      title: organisation.name,
      image: logo
    }));
  })));
};
SliceOrganisations.defaultProps = SliceOrganisationsDefaultProps;
SliceOrganisations.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;